import React from "react";
import contentfulRichText from "../util/contentfulRichText";
import Link from "../atoms/Link";

export default ({ title, content, link }) =>
    <div className="o-contact-block">
        <div className="heading heading--fsb">{ title }</div>
        <div className="o-contact-block__content u-small-text">
            { contentfulRichText(content) }
        </div>
        { link && <Link className="o-contact-block__btn a-btn" link={ link }/> }
    </div>;
